import { AppliedFacets, FacetOption } from '../../../../../types/facets';

const addFacetNameToOption = (facetName: string) => (
  (option: FacetOption) => Object.assign(option, { facetName })
);

const ignoreFacets = (facetsToIgnore: string[]) => (
  ([facetName]: [string, FacetOption]) => !facetsToIgnore.includes(facetName)
);

const extractOptions = () => (
  ([facetName, facetOptions]: [string, FacetOption]) => facetOptions.map(addFacetNameToOption(facetName))
);

const combineAllOptions = (combinedOptions: FacetOption[], options: FacetOption[]) => (
  combinedOptions.concat(options)
);

const getId = (option: FacetOption) => option.id || option.searchFacetOptionId;

const getName = (option: FacetOption) => option.name || option.searchFacetOptionValue;

const getDisplayName = (option: FacetOption) => option.tagDisplayLabel ?? getName(option);

const adaptAppliedOption = (option: FacetOption) => ({
  id: getId(option),
  name: getName(option),
  facetName: option.facetName,
  displayName: getDisplayName(option),
});

const inlineFacetTagDataAdapter = (appliedFacets: AppliedFacets, ignoredFacets: string[] = []) => (
  Object.entries(appliedFacets)
    .filter(ignoreFacets(ignoredFacets))
    .map(extractOptions())
    .reduce(combineAllOptions, [])
    .map(adaptAppliedOption)
);

export default inlineFacetTagDataAdapter;
